module.exports = "/static/assets/7c74d1187f403ff0ce14c54989f8cb09.png";